import React from 'react';
import PropTypes from 'prop-types';
import { getImagem } from '../../utils/imagens';

const Patrocinadores = ({ patrocinadores, className }) => {
  if (!patrocinadores) {
    return null;
  }

  const renderGrupo = (grupo, keySuffix = '') => {
    if (grupo.tipo === 'patrocinio-grid') {
      return (
        <div
          key={`grid-${keySuffix}`}
          className="in-init-ctn-grid-partiners-item"
        >
          <div className="patrocinio-grid">
            {grupo.colunas.map((col) => (
              <div key={col.label} className="patrocinio-col">
                <p>{col.label}</p>
                <div className="logos">
                  {col.logos.map((logo) => {
                    const src = getImagem(logo.imagem);
                    return src ? (
                      <a
                        key={logo.imagem}
                        href={logo.href || '#'}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <img src={src} alt={logo.alt} width={logo.width} />
                      </a>
                    ) : null;
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    const logos = grupo.logos || [];
    const hasLogos = logos.some((l) => getImagem(l.imagem));
    if (!hasLogos) return null;

    const grupoKey =
      grupo.label || (logos[0] ? logos[0].imagem : `grupo-${keySuffix}`);

    return (
      <div
        key={`${grupoKey}-${keySuffix}`}
        className={`in-init-ctn-grid-partiners-item${
          grupo.comLinhas ? ' item-com-linhas' : ''
        }${grupo.classeItem ? ` ${grupo.classeItem}` : ''}`}
      >
        {grupo.label && (
          <p
            className={`${grupo.comLinhas ? 'title-linhas' : ''}${
              grupo.classeTitulo ? ` ${grupo.classeTitulo}` : ''
            }`}
          >
            {grupo.label.split('\n').map((linha) => (
              <React.Fragment key={linha}>
                {linha}
                <br />
              </React.Fragment>
            ))}
          </p>
        )}
        <div className={`logos${grupo.classe ? ` ${grupo.classe}` : ''}`}>
          {logos.map((logo) => {
            const src = getImagem(logo.imagem);
            return src ? (
              <a
                key={logo.imagem}
                href={logo.href || '#'}
                rel="noreferrer"
                target="_blank"
              >
                <img src={src} alt={logo.alt} width={logo.width} />
              </a>
            ) : null;
          })}
        </div>
      </div>
    );
  };

  const temLinhas =
    Array.isArray(patrocinadores.linhas) && patrocinadores.linhas.length > 0;
  const temGrupos =
    Array.isArray(patrocinadores.grupos) && patrocinadores.grupos.length > 0;

  if (!temLinhas && !temGrupos) {
    return null;
  }

  return (
    <div className={`regua-patrocinio${className ? ` ${className}` : ''}`}>
      <p className="title-regua">{patrocinadores.titulo || 'Patrocínio'}</p>
      <div
        className={`in-init-ctn-grid-partiners${
          temLinhas ? ' in-init-ctn-grid-partiners--linhas' : ''
        }`}
      >
        {temLinhas
          ? patrocinadores.linhas.map((linha, i) => {
              const rowKey =
                linha
                  .map((g) => g.label || (g.logos && g.logos[0]?.imagem) || '')
                  .join('_') || `row-${i}`;
              return (
                <div key={rowKey} className="in-init-ctn-grid-partiners-row">
                  {linha.map((grupo, gIndex) =>
                    renderGrupo(grupo, `${grupo.label || gIndex}-${rowKey}`)
                  )}
                </div>
              );
            })
          : patrocinadores.grupos.map((grupo, gIndex) =>
              renderGrupo(grupo, grupo.label || `${gIndex}`)
            )}
      </div>
    </div>
  );
};

const logoPropType = PropTypes.shape({
  href: PropTypes.string,
  imagem: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.number
});

const grupoPropType = PropTypes.shape({
  tipo: PropTypes.string,
  label: PropTypes.string,
  classe: PropTypes.string,
  classeItem: PropTypes.string,
  classeTitulo: PropTypes.string,
  comLinhas: PropTypes.bool,
  colunas: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      comLinhas: PropTypes.bool,
      logos: PropTypes.arrayOf(logoPropType).isRequired
    })
  ),
  logos: PropTypes.arrayOf(logoPropType)
});

Patrocinadores.propTypes = {
  patrocinadores: PropTypes.shape({
    titulo: PropTypes.string,
    grupos: PropTypes.arrayOf(grupoPropType),
    linhas: PropTypes.arrayOf(PropTypes.arrayOf(grupoPropType))
  }).isRequired,
  className: PropTypes.string
};

Patrocinadores.defaultProps = {
  className: null
};

export default Patrocinadores;
